module.exports = __webpack_public_path__ + "static/img/dr-ahmed-omar.3d78c664.jpg";